import React, { Component } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Auth from '../services/auth';
import TablePagination from '@material-ui/core/TablePagination';
import Box from '@material-ui/core/Box';
import TxCrossmapDataAccess from '../services/TxCrossmapDataAccess.js';
import { Prompt, Redirect } from 'react-router-dom';
import CircularProgress from '@material-ui/core/CircularProgress';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import TextField from '@material-ui/core/TextField';

const AppInsights = {
    trackException: (error) => { console.error('AppInsights Error:', error); }
}

const txCrossmapDataAccess = new TxCrossmapDataAccess();
const auth = new Auth();

const styles = theme => ({
    root: {
        flexGrow: 1,
        padding: theme.spacing(3)
    },
    filterCard: {
        marginBottom: theme.spacing(3),
        padding: theme.spacing(0),
        paddingTop: theme.spacing(1)
    },
    inputLabel: {
        paddingLeft: 2,
        marginLeft: 18,
        marginTop: -10,
        width: '100%',
    },
    formControl: {
        width: '100%',
        paddingLeft: 5,
        minWidth: 120,
        marginRight: theme.spacing(2)
    },
    submitButton: {
        minHeight: 40,
        minWidth: 150,
        marginRight: theme.spacing(2)
    },
    submitButtonContainer: {
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: theme.spacing(2),
        minHeight: 40
    },
    resetButton: {
        minHeight: 20,
        minWidth: 75,
        marginRight: theme.spacing(2)
    },
    tableContainer: {
        marginTop: theme.spacing(2)
    },
    emptyTable: {
        textAlign: 'center',
        padding: theme.spacing(4),
        color: theme.palette.text.secondary
    },
    kpiSelect: {
        minWidth: 150
    },
    accessDenied: {
        textAlign: 'center',
        marginTop: theme.spacing(4)
    },
    loadingCell: {
        paddingTop: 40,
        paddingBottom: 40,
        backgroundColor: '#f9f9f9'
    },
    columnFilterInput: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(0),
        minWidth: 80,
    }
});

function desc(a, b, orderBy) {
    const valA = a[orderBy] === null || a[orderBy] === undefined ? '' : a[orderBy];
    const valB = b[orderBy] === null || b[orderBy] === undefined ? '' : b[orderBy];

    if (valB < valA) {
        return -1;
    }
    if (valB > valA) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

const headCells = [
    { id: 'ID', label: 'ID', filterable: true },
    { id: 'System', label: 'System', filterable: false },
    { id: 'Client', label: 'Client', filterable: false },
    { id: 'TransactionType', label: 'Transaction Type', filterable: true },
    { id: 'TransactionCode', label: 'Transaction Code', filterable: true },
    { id: 'TransactionDescription', label: 'Transaction Description', filterable: true },
    { id: 'KPI', label: 'KPI', filterable: false },
];

class TransactionCrossmap extends Component {
    displayName = TransactionCrossmap.name;

    constructor(props) {
        super(props);

        this.state = {
            systems: [],
            clients: [],
            hasAccess: auth.isInADDGroup(),
            selectedSystem: '',
            selectedClient: '',
            hasUnsavedChanges: false,
            showConfirmDialog: false,
            pendingAction: null,
            tableData: [],

            originalTableData: [], 
            changedRows: {},
            showConfirmBeforeToSave: false,
            page: 0,
            rowsPerPage: 10,
            blockButton: false,
            hasSearched: false,
            isLoading: false,
            kpiOptions: [
                'Select KPI',
                'BAD DEBT',
                'COLLECTION AGENCY RECOVERY',
                'COLLECTION AGENCY REFERRAL',
                'CONTRACTUAL ADJUSTMENT',
                'DENIAL',
                'INITIAL DENIAL',
                'RECOUPMENT',
                'REFUND'
            ],
            order: 'asc',
            orderBy: 'ID',
            columnFilters: headCells.reduce((acc, cell) => ({ ...acc, [cell.id]: '' }), {})
        };

        // Bind methods
        this.handleSystemChange = this.handleSystemChange.bind(this);
        this.handleClientChange = this.handleClientChange.bind(this);
        this.handleKpiChange = this.handleKpiChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleResetFilters = this.handleResetFilters.bind(this);
        this.handleConfirmDialog = this.handleConfirmDialog.bind(this);
        this.handleBeforeUnload = this.handleBeforeUnload.bind(this);
        this.checkUnsavedChanges = this.checkUnsavedChanges.bind(this);
        this.confirmSave = this.confirmSave.bind(this);
        this.saveChanges = this.saveChanges.bind(this);
        this.handleResetRow = this.handleResetRow.bind(this);
        this.handleRequestSort = this.handleRequestSort.bind(this);
        this.handleColumnFilterChange = this.handleColumnFilterChange.bind(this);
    }

    componentDidMount() {
        document.title = 'Transaction Crossmap - Surgical Notes RCM';
        window.addEventListener('beforeunload', this.handleBeforeUnload);
        this.loadPASSystems();
    }

    componentWillUnmount() {
        window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }

    handleError = (error) => {
        AppInsights.trackException({ exception: error });
    };

    handleBeforeUnload = (e) => {
        if (this.state.hasUnsavedChanges) {
            e.preventDefault();
            e.returnValue = '';
        }
    };

    checkUnsavedChanges(callback) {
        if (this.state.hasUnsavedChanges) {
            this.setState({
                showConfirmDialog: true,
                pendingAction: callback
            });
        } else {
            callback();
        }
    }

    handleRequestSort = (event, property) => {
        const isDesc = this.state.orderBy === property && this.state.order === 'desc';
        this.setState({
            order: isDesc ? 'asc' : 'desc',
            orderBy: property,
            page: 0
        });
    };

    handleColumnFilterChange(columnId, value) {
        this.setState(prevState => ({ 
            columnFilters: {
                ...prevState.columnFilters,
                [columnId]: value 
            },
            page: 0
        }));
    }

    resetColumnFilters() {
        return headCells.reduce((acc, cell) => ({ ...acc, [cell.id]: '' }), {});
    }

    getOriginalKpi = (rowId) => {
        const originalRow = this.state.originalTableData.find(row => row.ID === rowId);
        return originalRow ? (originalRow.KPI || '').toUpperCase() : '';
    }
    
    handleSystemChange = (event) => {
        const newSystem = event.target.value;

        this.checkUnsavedChanges(() => {
            this.setState({
                selectedSystem: newSystem,
                selectedClient: '',
                hasUnsavedChanges: false,
                clients: [],
                tableData: [],
                originalTableData: [],
                hasSearched: false,
                columnFilters: this.resetColumnFilters()
            });

            if (!newSystem) return;

            this.setState({ isLoading: true });

            txCrossmapDataAccess.getClientsBySystem(newSystem)
                .then((rs) => {
                    if (rs) {
                        this.setState({ clients: rs, isLoading: false });
                    } else {
                        this.handleError("No clients configured for selected system " + newSystem);
                        this.setState({ isLoading: false });
                    }
                })
                .catch((error) => {
                    this.handleError(error);
                    window.alert("No clients configured for selected system " + newSystem);
                    this.setState({ isLoading: false });
                });
        });
    };

    handleClientChange = (event) => {
        const newClient = event.target.value;

        this.checkUnsavedChanges(() => {
            this.setState({
                selectedClient: newClient,
                hasUnsavedChanges: false,
                tableData: [],
                originalTableData: [],
                changedRows: {},
                columnFilters: this.resetColumnFilters()
            });
        });
    };

    handleSearch = () => {
        if (this.state.selectedSystem && this.state.selectedClient) {
            
            this.setState({ isLoading: true, tableData: [], originalTableData: [], hasSearched: false, columnFilters: this.resetColumnFilters() });

            txCrossmapDataAccess.getFilteredData(this.state.selectedSystem, this.state.selectedClient)
                .then((rs) => {
                    if (rs) {
                        const originalData = rs.map(row => ({ ...row })); 
                        this.setState({ 
                            tableData: rs, 
                            originalTableData: originalData,
                            isLoading: false, 
                            hasUnsavedChanges: false, 
                            changedRows: {}, 
                            hasSearched: true,
                            page: 0
                        })
                    } else {
                        this.handleError("No feteched data for selected filters");
                        this.setState({ tableData: [], isLoading: false, originalTableData: [], hasSearched: true, page: 0 });
                    }
                })
                .catch((error) => {
                    this.handleError(error);
                    window.alert(`Error fetching data: ${error.message || error}`);
                    this.setState({ isLoading: false, tableData: [], originalTableData: [], hasSearched: true });
                });
        }
    };

    handleResetFilters = () => {
        this.checkUnsavedChanges(() => {
            this.setState({
                selectedSystem: '',
                selectedClient: '',
                tableData: [],
                originalTableData: [],
                hasUnsavedChanges: false,
                changedRows: {},
                hasSearched: false,
                page: 0,
                order: 'asc',
                orderBy: 'ID',
                columnFilters: this.resetColumnFilters()
            });
        });
    };

    handleKpiChange = (rowId, newValue) => {
        const originalKpi = this.getOriginalKpi(rowId);

        this.setState((prevState) => {
            const updated = prevState.tableData.map((row) =>
                row.ID === rowId ? { ...row, KPI: newValue } : row
            );

            const changedRows = { ...prevState.changedRows };
            
            if (newValue === originalKpi) {
                delete changedRows[rowId];
            } else {
                const changedRow = updated.find((r) => r.ID === rowId);
                if (changedRow) changedRows[rowId] = changedRow;
            }
            
            const hasUnsavedChanges = Object.keys(changedRows).length > 0;

            return { tableData: updated, changedRows, hasUnsavedChanges };
        });
    };
    
    handleResetRow = (rowId) => {
        const originalKpi = this.getOriginalKpi(rowId);

        this.setState(prevState => {
            const updatedTableData = prevState.tableData.map(row => 
                row.ID === rowId ? { ...row, KPI: originalKpi } : row
            );

            const updatedChangedRows = { ...prevState.changedRows };
            delete updatedChangedRows[rowId];

            const hasUnsavedChanges = Object.keys(updatedChangedRows).length > 0;
            
            return {
                tableData: updatedTableData,
                changedRows: updatedChangedRows,
                hasUnsavedChanges: hasUnsavedChanges,
            };
        });
    };

    confirmSave = () => {
        if (Object.keys(this.state.changedRows).length === 0)
            return;

        this.setState({ showConfirmBeforeToSave: true });
    };

    saveChanges = async () => {
        const rowsToUpdate = Object.values(this.state.changedRows);

        if (rowsToUpdate.length === 0)
            return;

        this.setState({ isLoading: true, blockButton: true });

        try {
            await txCrossmapDataAccess.processTransactionCrossmap(rowsToUpdate);
            
            const updatedOriginalData = this.state.originalTableData.map(originalRow => {
                const updatedRow = rowsToUpdate.find(r => r.ID === originalRow.ID);
                return updatedRow ? { ...originalRow, KPI: updatedRow.KPI } : originalRow;
            });
            
            this.setState({ 
                changedRows: {}, 
                showConfirmBeforeToSave: false, 
                isLoading: false, 
                blockButton: false, 
                hasUnsavedChanges: false,
                originalTableData: updatedOriginalData
            });
            alert('Changes submitted successfully!');
        } catch (error) {
            this.setState({ isLoading: false, showConfirmBeforeToSave: false, blockButton: false });
            this.handleError(error);
            window.alert(`Error saving changes: ${error.message || error}`);
        }
    };

    handleConfirmDialog = (confirmed) => {
        if (confirmed && this.state.pendingAction) {
            this.setState({
                showConfirmDialog: false,
                hasUnsavedChanges: false
            }, () => {
                this.state.pendingAction();
            });
        } else {
            this.setState({
                showConfirmDialog: false,
                pendingAction: null
            });
        }
    };

    // Load PAS Systems
    loadPASSystems() {

        this.setState({ isLoading: true });

        txCrossmapDataAccess.getPASSystems()
            .then((rs) => {
                if (rs) {
                    this.setState({ systems: rs, isLoading: false });
                } else {
                    this.handleError('No systems configured');
                    this.setState({ isLoading: false });
                }
            })
            .catch((error) => {
                this.handleError(error);
                window.alert('No systems configured');
                this.setState({ isLoading: false });
                return;
            });
    }

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    render() {
        const { classes } = this.props;
        const {
            hasAccess,
            selectedSystem,
            selectedClient,
            hasUnsavedChanges,
            showConfirmDialog,
            showConfirmBeforeToSave,
            systems,
            clients,
            kpiOptions,
            tableData,
            page,
            rowsPerPage,
            blockButton,
            hasSearched,
            isLoading,
            changedRows,
            order,
            orderBy,
            columnFilters
        } = this.state;

        if (!hasAccess) {
            return <Redirect to="/" />;
        }

        let filteredData = tableData;
        
        const activeFilters = Object.entries(columnFilters).filter(([key, value]) => value.trim() !== '');

        if (activeFilters.length > 0) {
            filteredData = tableData.filter(row => {
                return activeFilters.every(([columnId, filterValue]) => {
                    const rowValue = String(row[columnId] || '').toLowerCase();
                    return rowValue.includes(filterValue.toLowerCase());
                });
            });
        }

        const orderedData = stableSort(filteredData, getSorting(order, orderBy));

        const paginatedData = orderedData.slice(
            page * rowsPerPage,
            page * rowsPerPage + rowsPerPage
        );
        
        const showNoFilterResults = tableData.length > 0 && paginatedData.length === 0 && activeFilters.length > 0;
        const showNoInitialResults = tableData.length === 0;

        const totalColumns = headCells.length + 1;


        return (
            <>
                <Prompt
                    when={hasUnsavedChanges}
                    message="You have unsaved changes. Are you sure you want to continue? Your changes will be lost."
                />
                <Container maxWidth="xl" className={classes.root}>
                    <h2>End of Month Transaction Crossmap</h2>

                    <Card className={classes.filterCard}>
                        <CardContent>
                            <Grid container spacing={1} alignItems="center">
                                <Grid item xs={12} sm={4} md={2}>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel
                                            id="System"
                                            className={classes.inputLabel}>System</InputLabel>
                                        <Select
                                            value={selectedSystem}
                                            onChange={this.handleSystemChange}
                                            id="System"
                                            labelId="System"
                                            variant="outlined"
                                            margin="dense"
                                            label="System"
                                            fullWidth
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "left"
                                                },
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left"
                                                },
                                                getContentAnchorEl: null
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>Select System</em>
                                            </MenuItem>
                                            {systems.map((system) => (
                                                <MenuItem key={system.ID} value={system.ID}>
                                                    {system.ID}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={4} md={2}>
                                    <FormControl className={classes.formControl}>
                                        <InputLabel
                                            id="Client"
                                            className={classes.inputLabel}>Client</InputLabel>
                                        <Select
                                            value={selectedClient}
                                            onChange={this.handleClientChange}
                                            disabled={!selectedSystem}
                                            id="Client"
                                            labelId="Client"
                                            variant="outlined"
                                            margin="dense"
                                            label="Client"
                                            fullWidth
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "left"
                                                },
                                                transformOrigin: {
                                                    vertical: "top",
                                                    horizontal: "left"
                                                },
                                                getContentAnchorEl: null
                                            }}
                                        >
                                            <MenuItem value="">
                                                <em>Select Client</em>
                                            </MenuItem>
                                            {clients.map((client) => (
                                                <MenuItem key={client.ID} value={client.ID}>
                                                    {client.Client}
                                                </MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12} sm={4} md={4} style={{ display: 'flex', gap: '8px' }}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        className={classes.submitButton}
                                        disabled={!selectedSystem || !selectedClient || isLoading}
                                        onClick={this.handleSearch}
                                        style={{ marginRight: 0 }}
                                    >
                                        Search
                                    </Button>

                                    <Button
                                        variant="outlined"
                                        color="default"
                                        className={classes.submitButton}
                                        disabled={(!selectedSystem && !selectedClient) || isLoading}
                                        onClick={this.handleResetFilters}
                                        style={{ marginRight: 0 }}
                                    >
                                        Reset Filters
                                    </Button>
                                </Grid>

                                <Grid item xs={12} sm={4} md={4} className={classes.submitButtonContainer}>
                                    <Button
                                        variant="contained"
                                        color="secondary"
                                        className={classes.submitButton}
                                        disabled={!hasUnsavedChanges || isLoading || blockButton} 
                                        onClick={this.confirmSave}
                                        style={{ marginRight: 0 }}
                                    >
                                        Submit Changes
                                    </Button>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>

                    <TableContainer component={Paper} className={classes.tableContainer}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    {headCells.map((headCell) => (
                                        <TableCell
                                            key={headCell.id}
                                            sortDirection={orderBy === headCell.id ? order : false}
                                            padding={headCell.id === 'KPI' ? 'none' : 'default'}
                                        >
                                            {headCell.id === 'KPI' ? (
                                                <Typography variant="subtitle2">{headCell.label}</Typography>
                                            ) : (
                                                <TableSortLabel
                                                    active={orderBy === headCell.id}
                                                    direction={order}
                                                    onClick={(event) => this.handleRequestSort(event, headCell.id)}
                                                >
                                                    <Typography variant="subtitle2">{headCell.label}</Typography>
                                                </TableSortLabel>
                                            )}
                                            
                                            {headCell.filterable && (
                                                <TextField
                                                    label=""
                                                    placeholder="Search..."
                                                    variant="standard"
                                                    size="small"
                                                    fullWidth
                                                    className={classes.columnFilterInput}
                                                    value={columnFilters[headCell.id]}
                                                    onChange={(e) => this.handleColumnFilterChange(headCell.id, e.target.value)}
                                                    onClick={(e) => e.stopPropagation()} 
                                                    onKeyDown={(e) => e.stopPropagation()}
                                                />
                                            )}
                                        </TableCell>
                                    ))}
                                    {/* === Actions column === */}
                                    <TableCell>
                                        <Typography variant="subtitle2">Actions</Typography>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {isLoading ? (
                                    <TableRow>
                                        <TableCell colSpan={totalColumns} align="center" className={classes.loadingCell}>
                                            <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: 8 }}>
                                                <CircularProgress size={20} />
                                                <Typography variant="body1" color="textSecondary" style={{ marginLeft: 8 }}>
                                                    Loading...
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ) : showNoFilterResults ? (
                                    <TableRow>
                                        <TableCell colSpan={totalColumns} align="center" className={classes.loadingCell}>
                                            <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: 8 }}>                                                
                                                <Typography variant="body1" color="textSecondary" style={{ fontStyle: 'italic' }}>
                                                    No se encontraron resultados que coincidan con los filtros aplicados.
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ) : showNoInitialResults ? (
                                     <TableRow>
                                        <TableCell colSpan={totalColumns} align="center" className={classes.loadingCell}>
                                            <Box display="flex" alignItems="center" justifyContent="center" style={{ gap: 8 }}>                                                
                                                <Typography variant="body1" color="textSecondary" style={{ fontStyle: 'italic' }}>
                                                    {!selectedSystem || !selectedClient
                                                        ? 'Please select System and Client, then click Search to view data'
                                                        : !hasSearched
                                                            ? 'Click Search to load data for the selected filters'
                                                            : 'No results found for the selected filters'
                                                    }
                                                </Typography>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    paginatedData.map((row) => (
                                        <TableRow key={row.ID}>
                                            <TableCell>{row.ID}</TableCell>
                                            <TableCell>{row.System}</TableCell>
                                            <TableCell>{row.Client}</TableCell>
                                            <TableCell>{row.TransactionType}</TableCell>
                                            <TableCell>{row.TransactionCode}</TableCell>
                                            <TableCell>{row.TransactionDescription}</TableCell>
                                            <TableCell>
                                                <FormControl className={classes.kpiSelect}>
                                                    <Select
                                                        value={(row.KPI || '').toUpperCase()}
                                                        onChange={(e) => this.handleKpiChange(row.ID, e.target.value.toUpperCase())}
                                                    >
                                                        {kpiOptions.map((option) => (
                                                            <MenuItem key={option} value={option === 'Select KPI' ? '' : option}>
                                                                {option}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </TableCell>
                                            <TableCell> 
                                                {changedRows[row.ID] && (
                                                    <Button 
                                                        size="small"
                                                        variant="contained"
                                                        color="primary"
                                                        className={classes.resetButton}
                                                        onClick={() => this.handleResetRow(row.ID)}
                                                        disabled={isLoading || blockButton}
                                                    >
                                                        Reset
                                                    </Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                        <Box display="flex" justifyContent="center" mt={2}>
                            <TablePagination
                                component="div"
                                count={filteredData.length}
                                page={page}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                rowsPerPageOptions={[5, 10, 25, 50]}
                            />
                        </Box>
                    </TableContainer>

                    {/* Confirmation Dialogs remain unchanged */}

                    <Dialog
                        open={showConfirmDialog}
                        onClose={() => this.handleConfirmDialog(false)}
                    >
                        <DialogTitle>Unsaved Changes</DialogTitle>
                        <DialogContent>
                            <DialogContentText>
                                You have unsaved changes. Are you sure you want to continue?
                                Your changes will be lost.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={() => this.handleConfirmDialog(false)} color="primary">
                                Cancel
                            </Button>
                            <Button onClick={() => this.handleConfirmDialog(true)} color="secondary">
                                Continue
                            </Button>
                        </DialogActions>
                    </Dialog>

                    {showConfirmBeforeToSave && (
                        <Dialog
                            open={showConfirmBeforeToSave}
                            onClose={() => this.setState({ showConfirmBeforeToSave: false })}
                        >
                            <DialogTitle>Confirm changes</DialogTitle>
                            <DialogContent>
                                <p>The following changes will be saved:</p>
                                <ul>
                                    {Object.values(this.state.changedRows).map((row) => (
                                        <li key={row.ID}>
                                            {row.ID} - {row.TransactionType} - {row.TransactionDescription} - {row.KPI} - {row.System}
                                        </li>
                                    ))}
                                </ul>
                            </DialogContent>
                            <DialogActions>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.submitButton}
                                    disabled={blockButton}
                                    onClick={() => this.setState({ showConfirmBeforeToSave: false })}>Cancel</Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.submitButton}
                                    disabled={blockButton}
                                    onClick={this.saveChanges} >Confirm</Button>
                            </DialogActions>
                        </Dialog>
                    )}
                </Container>
            </>
        );
    }
}

export default withStyles(styles)(TransactionCrossmap);